import styled from 'styled-components'

export const CanvasWrapper = styled.div`
  & > canvas {
    width: 100%;
  }
`
